import React from 'react';

import { ICourse } from '../../../../types';
import { Box } from '@chakra-ui/react';
import { SummaryGroup } from '../../../Summary/SummaryGroup';
import { SummaryRow } from '../../../Summary/SummaryRow';
import { useTranslation } from "react-i18next";

interface Props {
  showRisks: boolean;
  courses?: Array<ICourse>;
  riskList?: string[];
}

function CourseOfferEvidence({ courses: allCourses }: Props) {
    const { t } = useTranslation('forms.visa');
  const courses = allCourses?.filter(course => course && course.courseName !== undefined && course.courseName !== '');

  return (
    <>
      {courses !== undefined && (
        <>
          <SummaryGroup title={t('forms.visa:evidenceUsedToObtainOffer')}>
            <Box as="ol" pl={8}>
              {courses.map((course: ICourse, index: number) => {
                return (
                  <React.Fragment key={`course-${index}`}>
                    <SummaryRow label={t('forms.visa:course')} value={course.courseName} />

                    {course.offerEvidence && (
                      <SummaryRow label={t('forms.visa:evidenceUsedForOffer')} value={course.offerEvidence} />
                    )}
                  </React.Fragment>
                );
              })}
            </Box>
          </SummaryGroup>
        </>
      )}
    </>
  );
}

export default CourseOfferEvidence;
